import { Component, Input, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { PollResult, PollResultValue } from "app/frontend/lib/timeline/timeline-item/poll-result/poll-result.type";
import { PollResultService } from "app/frontend/lib/timeline/timeline-item/poll-result/poll-result.service";
import { CommonModule } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";

@Component({
    selector: 'five-stars-question-result-chart',
    templateUrl: './five-stars-question-result-chart.component.html',
    styleUrls: ['./../../../../timeline/timeline-item/poll-result/five-stars-poll-result/five-stars-poll-result.component.scss', './five-stars-question-result-chart.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        CommonModule,
        TranslateModule,
    ]
})
export class FiveStarsQuestionResultChartComponent implements OnInit {

    protected average: {
        averageScore: string; // toFixed methode return sting from number
        people: number
    }
    dontWantToAnswerItem: PollResultValue;
    participationCount: number;
   
    @Input() results: PollResult

    constructor(
        private pollResultService: PollResultService
    ) { }

    ngOnInit(): void {
        this.average = this.pollResultService.formatFiveStarsPollResult(this.results.values)
        this.dontWantToAnswerItem = this.results.values.find(x => x.choice === "don-t-want-to-answer")
        this.participationCount = this.pollResultService.getParticipationCount(this.results.values)
    }

}